// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "codesandbox/v1/codesandbox.proto" (package "codesandbox.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Internal RPCs for the Control tab's code sandbox and the code editors'
// language servers.
//
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../google/protobuf/timestamp";
/**
 * @generated from protobuf message codesandbox.v1.RunProgramRequest
 */
export interface RunProgramRequest {
    /**
     * Caller-generated identifier, used to stop the run. Only ever resolved
     * alongside the caller's own identity, so a guessed value reaches nothing.
     *
     * @generated from protobuf field: string run_id = 1;
     */
    runId: string;
    /**
     * The part the program runs against; the caller must have control access.
     *
     * @generated from protobuf field: string part_id = 2;
     */
    partId: string;
    /**
     * @generated from protobuf field: codesandbox.v1.Language language = 3;
     */
    language: Language;
    /**
     * The whole program, as a single file.
     *
     * @generated from protobuf field: string source = 4;
     */
    source: string;
    /**
     * The editor session to run in, from StartEditorSession. It must be the
     * caller's own session for this part. Unset or blank, the program runs in a
     * sandbox of its own that ends with the run.
     *
     * @generated from protobuf field: optional string session_id = 5;
     */
    sessionId?: string;
}
/**
 * Sent before the program is compiled, marking "starting" -> "building". Only a
 * session run of a language with a build step sends it. The build's output
 * arrives as ProgramOutput, and a build that fails ends the run with its exit
 * code in ProgramFinished, without ProgramStarted.
 *
 * @generated from protobuf message codesandbox.v1.ProgramBuilding
 */
export interface ProgramBuilding {
}
/**
 * Sent once the program is launched, marking "starting" or "building" ->
 * "running".
 *
 * @generated from protobuf message codesandbox.v1.ProgramStarted
 */
export interface ProgramStarted {
}
/**
 * A chunk of program output. Not guaranteed to be line-aligned.
 *
 * @generated from protobuf message codesandbox.v1.ProgramOutput
 */
export interface ProgramOutput {
    /**
     * @generated from protobuf field: codesandbox.v1.OutputStream stream = 1;
     */
    stream: OutputStream;
    /**
     * @generated from protobuf field: string text = 2;
     */
    text: string;
}
/**
 * Sent once the program has exited and nothing it started is left running. A
 * run's own sandbox is terminated right after; a session's keeps running.
 *
 * @generated from protobuf message codesandbox.v1.ProgramFinished
 */
export interface ProgramFinished {
    /**
     * @generated from protobuf field: int32 exit_code = 1;
     */
    exitCode: number;
}
/**
 * @generated from protobuf message codesandbox.v1.RunProgramResponse
 */
export interface RunProgramResponse {
    /**
     * @generated from protobuf oneof: event
     */
    event: {
        oneofKind: "started";
        /**
         * @generated from protobuf field: codesandbox.v1.ProgramStarted started = 1;
         */
        started: ProgramStarted;
    } | {
        oneofKind: "output";
        /**
         * @generated from protobuf field: codesandbox.v1.ProgramOutput output = 2;
         */
        output: ProgramOutput;
    } | {
        oneofKind: "finished";
        /**
         * @generated from protobuf field: codesandbox.v1.ProgramFinished finished = 3;
         */
        finished: ProgramFinished;
    } | {
        oneofKind: "building";
        /**
         * @generated from protobuf field: codesandbox.v1.ProgramBuilding building = 4;
         */
        building: ProgramBuilding;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message codesandbox.v1.StopProgramRequest
 */
export interface StopProgramRequest {
    /**
     * @generated from protobuf field: string run_id = 1;
     */
    runId: string;
    /**
     * The part the run is bound to. A wrong value matches nothing, so it is
     * reported as absent.
     *
     * @generated from protobuf field: string part_id = 2;
     */
    partId: string;
    /**
     * The editor session the run was started in, as on RunProgramRequest. Unset
     * for a run that had a sandbox of its own.
     *
     * @generated from protobuf field: optional string session_id = 3;
     */
    sessionId?: string;
}
/**
 * @generated from protobuf message codesandbox.v1.StopProgramResponse
 */
export interface StopProgramResponse {
}
/**
 * @generated from protobuf message codesandbox.v1.CheckHealthRequest
 */
export interface CheckHealthRequest {
}
/**
 * @generated from protobuf message codesandbox.v1.RecordRunRequest
 */
export interface RecordRunRequest {
    /**
     * The part the run is bound to; the caller must have control access to it.
     *
     * @generated from protobuf field: string part_id = 1;
     */
    partId: string;
    /**
     * @generated from protobuf field: codesandbox.v1.Language language = 2;
     */
    language: Language;
}
/**
 * @generated from protobuf message codesandbox.v1.RecordRunResponse
 */
export interface RecordRunResponse {
}
/**
 * @generated from protobuf message codesandbox.v1.CheckHealthResponse
 */
export interface CheckHealthResponse {
    /**
     * True when a run attempted now would reach the provider. False is a
     * provider that is configured but unreachable, or refusing our credentials.
     *
     * @generated from protobuf field: bool healthy = 1;
     */
    healthy: boolean;
    /**
     * Why it is not healthy, for a human reading a log or a tooltip. Never
     * carries credentials or provider identifiers.
     *
     * @generated from protobuf field: string reason = 2;
     */
    reason: string;
}
/**
 * @generated from protobuf message codesandbox.v1.StartEditorSessionRequest
 */
export interface StartEditorSessionRequest {
    /**
     * PYTHON or GO. Selects the sandbox image and the language server.
     *
     * @generated from protobuf field: codesandbox.v1.Language language = 1;
     */
    language: Language;
    /**
     * @generated from protobuf oneof: target
     */
    target: {
        oneofKind: "partId";
        /**
         * The part the Control tab's code sandbox runs against. The caller must
         * have control access to it.
         *
         * @generated from protobuf field: string part_id = 2;
         */
        partId: string;
    } | {
        oneofKind: "moduleId";
        /**
         * The inline module being edited, as its registry item ID. The caller must
         * have write_packages on the organization that owns it.
         *
         * @generated from protobuf field: string module_id = 3;
         */
        moduleId: string;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message codesandbox.v1.StartEditorSessionResponse
 */
export interface StartEditorSessionResponse {
    /**
     * The session's handle, taken by StopEditorSession. Only ever resolved
     * alongside the caller's own identity, so a guessed value reaches nothing.
     *
     * @generated from protobuf field: string session_id = 1;
     */
    sessionId: string;
    /**
     * Where the session's language server is served, behind the provider's
     * connect-token proxy.
     *
     * @generated from protobuf field: string url = 2;
     */
    url: string;
    /**
     * Admits a connection to this one sandbox. A browser WebSocket cannot set
     * headers, so it is sent as the _modal_connect_token query parameter.
     *
     * @generated from protobuf field: string token = 3;
     */
    token: string;
    /**
     * When the sandbox reaches its hard lifetime and ends, however recently the
     * editor was used.
     *
     * @generated from protobuf field: google.protobuf.Timestamp expires_at = 4;
     */
    expiresAt?: Timestamp;
}
/**
 * @generated from protobuf message codesandbox.v1.StopEditorSessionRequest
 */
export interface StopEditorSessionRequest {
    /**
     * @generated from protobuf field: string session_id = 1;
     */
    sessionId: string;
}
/**
 * @generated from protobuf message codesandbox.v1.StopEditorSessionResponse
 */
export interface StopEditorSessionResponse {
}
/**
 * Language the program is written in, which selects the sandbox image and the
 * command used to execute it.
 *
 * @generated from protobuf enum codesandbox.v1.Language
 */
export enum Language {
    /**
     * @generated from protobuf enum value: LANGUAGE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: LANGUAGE_PYTHON = 1;
     */
    PYTHON = 1,
    /**
     * @generated from protobuf enum value: LANGUAGE_GO = 2;
     */
    GO = 2,
    /**
     * Runs in the browser, so it selects no image, and RunProgram and
     * StartEditorSession refuse it. Present because RecordRun counts it.
     *
     * @generated from protobuf enum value: LANGUAGE_TYPESCRIPT = 3;
     */
    TYPESCRIPT = 3
}
/**
 * Which of the program's output streams a chunk came from.
 *
 * @generated from protobuf enum codesandbox.v1.OutputStream
 */
export enum OutputStream {
    /**
     * @generated from protobuf enum value: OUTPUT_STREAM_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: OUTPUT_STREAM_STDOUT = 1;
     */
    STDOUT = 1,
    /**
     * @generated from protobuf enum value: OUTPUT_STREAM_STDERR = 2;
     */
    STDERR = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class RunProgramRequest$Type extends MessageType<RunProgramRequest> {
    constructor() {
        super("codesandbox.v1.RunProgramRequest", [
            { no: 1, name: "run_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "part_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "language", kind: "enum", T: () => ["codesandbox.v1.Language", Language, "LANGUAGE_"] },
            { no: 4, name: "source", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "session_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message codesandbox.v1.RunProgramRequest
 */
export const RunProgramRequest = new RunProgramRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProgramBuilding$Type extends MessageType<ProgramBuilding> {
    constructor() {
        super("codesandbox.v1.ProgramBuilding", []);
    }
}
/**
 * @generated MessageType for protobuf message codesandbox.v1.ProgramBuilding
 */
export const ProgramBuilding = new ProgramBuilding$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProgramStarted$Type extends MessageType<ProgramStarted> {
    constructor() {
        super("codesandbox.v1.ProgramStarted", []);
    }
}
/**
 * @generated MessageType for protobuf message codesandbox.v1.ProgramStarted
 */
export const ProgramStarted = new ProgramStarted$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProgramOutput$Type extends MessageType<ProgramOutput> {
    constructor() {
        super("codesandbox.v1.ProgramOutput", [
            { no: 1, name: "stream", kind: "enum", T: () => ["codesandbox.v1.OutputStream", OutputStream, "OUTPUT_STREAM_"] },
            { no: 2, name: "text", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message codesandbox.v1.ProgramOutput
 */
export const ProgramOutput = new ProgramOutput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProgramFinished$Type extends MessageType<ProgramFinished> {
    constructor() {
        super("codesandbox.v1.ProgramFinished", [
            { no: 1, name: "exit_code", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message codesandbox.v1.ProgramFinished
 */
export const ProgramFinished = new ProgramFinished$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RunProgramResponse$Type extends MessageType<RunProgramResponse> {
    constructor() {
        super("codesandbox.v1.RunProgramResponse", [
            { no: 1, name: "started", kind: "message", oneof: "event", T: () => ProgramStarted },
            { no: 2, name: "output", kind: "message", oneof: "event", T: () => ProgramOutput },
            { no: 3, name: "finished", kind: "message", oneof: "event", T: () => ProgramFinished },
            { no: 4, name: "building", kind: "message", oneof: "event", T: () => ProgramBuilding }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message codesandbox.v1.RunProgramResponse
 */
export const RunProgramResponse = new RunProgramResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StopProgramRequest$Type extends MessageType<StopProgramRequest> {
    constructor() {
        super("codesandbox.v1.StopProgramRequest", [
            { no: 1, name: "run_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "part_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "session_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message codesandbox.v1.StopProgramRequest
 */
export const StopProgramRequest = new StopProgramRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StopProgramResponse$Type extends MessageType<StopProgramResponse> {
    constructor() {
        super("codesandbox.v1.StopProgramResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message codesandbox.v1.StopProgramResponse
 */
export const StopProgramResponse = new StopProgramResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CheckHealthRequest$Type extends MessageType<CheckHealthRequest> {
    constructor() {
        super("codesandbox.v1.CheckHealthRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message codesandbox.v1.CheckHealthRequest
 */
export const CheckHealthRequest = new CheckHealthRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RecordRunRequest$Type extends MessageType<RecordRunRequest> {
    constructor() {
        super("codesandbox.v1.RecordRunRequest", [
            { no: 1, name: "part_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "language", kind: "enum", T: () => ["codesandbox.v1.Language", Language, "LANGUAGE_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message codesandbox.v1.RecordRunRequest
 */
export const RecordRunRequest = new RecordRunRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RecordRunResponse$Type extends MessageType<RecordRunResponse> {
    constructor() {
        super("codesandbox.v1.RecordRunResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message codesandbox.v1.RecordRunResponse
 */
export const RecordRunResponse = new RecordRunResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CheckHealthResponse$Type extends MessageType<CheckHealthResponse> {
    constructor() {
        super("codesandbox.v1.CheckHealthResponse", [
            { no: 1, name: "healthy", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message codesandbox.v1.CheckHealthResponse
 */
export const CheckHealthResponse = new CheckHealthResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StartEditorSessionRequest$Type extends MessageType<StartEditorSessionRequest> {
    constructor() {
        super("codesandbox.v1.StartEditorSessionRequest", [
            { no: 1, name: "language", kind: "enum", T: () => ["codesandbox.v1.Language", Language, "LANGUAGE_"] },
            { no: 2, name: "part_id", kind: "scalar", oneof: "target", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "module_id", kind: "scalar", oneof: "target", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message codesandbox.v1.StartEditorSessionRequest
 */
export const StartEditorSessionRequest = new StartEditorSessionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StartEditorSessionResponse$Type extends MessageType<StartEditorSessionResponse> {
    constructor() {
        super("codesandbox.v1.StartEditorSessionResponse", [
            { no: 1, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "expires_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message codesandbox.v1.StartEditorSessionResponse
 */
export const StartEditorSessionResponse = new StartEditorSessionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StopEditorSessionRequest$Type extends MessageType<StopEditorSessionRequest> {
    constructor() {
        super("codesandbox.v1.StopEditorSessionRequest", [
            { no: 1, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message codesandbox.v1.StopEditorSessionRequest
 */
export const StopEditorSessionRequest = new StopEditorSessionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StopEditorSessionResponse$Type extends MessageType<StopEditorSessionResponse> {
    constructor() {
        super("codesandbox.v1.StopEditorSessionResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message codesandbox.v1.StopEditorSessionResponse
 */
export const StopEditorSessionResponse = new StopEditorSessionResponse$Type();
/**
 * @generated ServiceType for protobuf service codesandbox.v1.CodeSandboxService
 */
export const CodeSandboxService = new ServiceType("codesandbox.v1.CodeSandboxService", [
    { name: "RunProgram", serverStreaming: true, options: {}, I: RunProgramRequest, O: RunProgramResponse },
    { name: "StopProgram", options: {}, I: StopProgramRequest, O: StopProgramResponse },
    { name: "CheckHealth", options: {}, I: CheckHealthRequest, O: CheckHealthResponse },
    { name: "RecordRun", options: {}, I: RecordRunRequest, O: RecordRunResponse },
    { name: "StartEditorSession", options: {}, I: StartEditorSessionRequest, O: StartEditorSessionResponse },
    { name: "StopEditorSession", options: {}, I: StopEditorSessionRequest, O: StopEditorSessionResponse }
]);
